"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var filter_1 = require("./filter");
function unionEquals(a, b, predicate, output) {
    if (predicate === void 0) { predicate = function (a, b) { return a === b; }; }
    var r = filter_1.dedup(a.concat(b), predicate);
    output && output.push.apply(output, filter_1.dedup(r.concat(output), predicate));
    return r;
}
exports.unionEquals = unionEquals;
exports.arrayUnion = unionEquals;
function arrayInterception(a, b, predicate, output) {
    if (predicate === void 0) { predicate = function (a, b) { return a === b; }; }
    var r = a.filter(function (a) { return b.find(function (b) { return predicate(a, b); }); });
    r = filter_1.dedup(r, predicate);
    output && output.push.apply(output, filter_1.dedup(r.concat(output), predicate));
    return r;
}
exports.arrayInterception = arrayInterception;
function arrayDifference(a, b, predicate, output) {
    if (predicate === void 0) { predicate = function (a, b) { return a === b; }; }
    var r = a.filter(function (a) { return !b.find(function (b) { return predicate(a, b); }); }).concat(b.filter(function (b) { return !a.find(function (a) { return predicate(b, a); }); }));
    r = filter_1.dedup(r, predicate);
    output && output.push.apply(output, filter_1.dedup(r.concat(output), predicate));
    return r;
}
exports.arrayDifference = arrayDifference;
//# sourceMappingURL=set.js.map